import React, {Suspense, lazy, useEffect} from 'react'
import {Redirect, Route, Switch} from 'react-router-dom'
import {FallbackView} from '../../_metronic/partials'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {MenuTestPage} from '../pages/MenuTestPage'
import {StockSale} from '../modules/stock/stock-sale'
import {SaleCooperation} from '../modules/SaleCooperation'
import {AuthHandle} from './AuthHandle'
import EditProfile from '../modules/profile/EditProfile'
import { Contact } from '../modules/Contact/Contact'
import TransferListRequest from '../modules/stock/stock-transfer/TransferListRequest'


export function PrivateRoutes() {
  const BuilderPageWrapper = lazy(() => import('../pages/layout-builder/BuilderPageWrapper'))
  const ProfilePageWrapper = lazy(() => import('../pages/dashboard/Profile/BuilderPageWrapper'))
  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
  const FinancePage = lazy(() => import('../../app/modules/Finance/index'))
  const StockShop = lazy(() => import('../../app/modules/stock/stock-shop/index'))
  const StockMarket = lazy(() => import('../../app/modules/stock/stock-market/index'))
  const StockTransfer = lazy(() => import('../../app/modules/stock/stock-transfer/index'))
  const StockTransferRequest = lazy(() => import('../../app/modules/stock/stock-transfer/StockTransferRequest'))
  const ShowTransferRequest = lazy(() => import('../../app/modules/stock/stock-transfer/ShowTransferRequest'))

  const StockSalesRequest = lazy(() => import('../../app/modules/stock/stock-transfer/StockSalesRequest'))
  const StockOrders = lazy(() => import('../../app/modules/stock/stock-orders/index'))
  const StockInstallment = lazy(() => import('../../app/modules/stock/stock-installment/index'))
  const StockReport = lazy(() => import('../../app/modules/stock/stock-report/index'))
  /// request
  const RequestPage = lazy(() => import('../../app/modules/Request/index'))
  const ListRequest = lazy(() => import('../../app/modules/Request/ListRequest'))
  /// service
  const ServicePage = lazy(() => import('../../app/modules/service/index'))

  /// payment
  const PaymentStatusPage = lazy(() => import('../../app/modules/pay/PaymentStatus'))

  /// Contract
  const ContractPage = lazy(() => import('../pages/Contract/index'))

  /// Q&A 
  const QuestionAnswer = lazy(() => import('../../app/modules/question/index'))

  return (
    <>
      <AuthHandle />
      <Suspense fallback={<FallbackView />}>
        <Switch>
          <Route path='/dashboard' component={DashboardWrapper} />
          <Route path='/builder' component={BuilderPageWrapper} />
          <Route path='/profile' component={ProfilePageWrapper} />
          <Route path='/crafted/pages/profile' component={ProfilePage} />
          <Route path='/crafted/pages/wizards' component={WizardsPage} />
          <Route path='/crafted/widgets' component={WidgetsPage} />
          <Route path='/crafted/account' component={AccountPage} />
          <Route path='/apps/chat' component={ChatPage} />
          <Route path='/menu-test' component={MenuTestPage} />

          {/*stock roues*/}
          <Route path='/stock/sales' component={StockSale} />
          <Route path='/stock/orders' component={StockOrders} />
          <Route path={'/stock/shop'} component={StockShop} />
          <Route path={'/stock/transfer'} component={StockTransfer} />
          <Route path={'/stock/transfer-request'} component={StockTransferRequest} />
          <Route path={'/stock/transfer-request-list'} component={TransferListRequest} />
          <Route path={'/stock/transfer-request-detail/:id'} component={ShowTransferRequest} />


          
          <Route path={'/stock/sales-request'} component={StockSalesRequest} />

          

          <Route path={'/stock/Installment'} component={StockInstallment} />
          <Route path={'/stock/report'} component={StockReport} />
          <Route path={'/stock/market'} component={StockMarket} />
          {/*end stock roues*/}

          {/*sale cooperation*/}
          <Route path='/sale/cooperation' component={SaleCooperation} />
          {/*end sale cooperation*/}

          {/*finance routes */}
          <Route path='/finance' component={FinancePage} />
          {/*finance routes */}

          {/*request routes*/}
          <Route path='/request/listrequest' component={TransferListRequest} />
          <Route path='/request' component={RequestPage} />
          {/*request routes*/}

          {/*service routes*/}
          <Route path='/service' component={ServicePage} />
          {/*service routes*/}

          {/* editprofile routes */}
          <Route path='/editprofile' component={EditProfile} />
          {/* editprofile routes */}

          {/*contact routes  */}
          <Route path='/contact' component={Contact} />
          {/*contact routes  */}

          {/*pay status*/}
          <Route path={'/paystatus/'} component={PaymentStatusPage} />
          {/*pay status*/}

          {/*contract routes*/}
          <Route path={'/contract/:order_token'} component={ContractPage}/>
          {/*contract routes*/}

          {/* Q&A routes */}
          <Route path={'/q&a'} component={QuestionAnswer}/>
          {/* end Q&A routes */}


          <Redirect from='/auth' to='/dashboard' />
          <Redirect exact from='/' to='/dashboard' />
          <Redirect to='error/404' />
        </Switch>
      </Suspense>
    </>
  )
}
